module.exports = __webpack_public_path__ + "static/img/20605563.512a48d2.png";